<template>
  <div class="rumie-button-toggle">
    <button
      type="button"
      class="rumie-button-toggle__button"
      v-for="opt in options"
      :key="opt.value"
      @click="onClick(opt)"
      :disabled="opt.disabled || disabled"
      :class="buttonClass(opt)"
    >
      {{opt.label}}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true,
      example: () => [
        { label: "Mobile", value: "mobile" },
        { label: "Tablet", value: "tablet" },
        { label: "Desktop", value: "desktop" }
      ]
    }
  },
  methods: {
    buttonClass(option) {
      return {
        "rumie-button-toggle__button--active": option.value === this.value
      };
    },
    onClick(option) {
      this.$emit("input", option.value);
    }
  }
};
</script>

<style scoped>
.rumie-button-toggle {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding-left: var(--spacing-1);
  padding-right: var(--spacing-1);
}

.rumie-button-toggle__button {
  width: 100%;
  background: var(--white);
  color: var(--primary-border);
  font-weight: var(--semibold);
  border: var(--border-2) solid var(--primary-border);
  padding: var(--spacing-3) var(--spacing-4);
  margin: calc(-1 * var(--spacing-1));
  cursor: pointer;
  box-sizing: border-box;
}

.rumie-button-toggle__button[disabled] {
  opacity: .5;
}

.rumie-button-toggle__button:first-child {
  border-top-left-radius: var(--border-radius-md);
  border-bottom-left-radius: var(--border-radius-md);
  margin-right: 0;
}

.rumie-button-toggle__button:last-child {
  border-top-right-radius: var(--border-radius-md);
  border-bottom-right-radius: var(--border-radius-md);
  margin-left: 0;
}

.rumie-button-toggle__button--active {
  background: var(--primary-gradient);
  color: var(--white);
  font-weight: var(--semibold);
}
</style>
